export const GoToStoreOutlineSVG = (props) => (
  <svg height="34" viewBox="0 0 34 34" width="34" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      transform="translate(1 1)"
    >
      <path
        d="m32 16.001044c0 8.8347146-7.1642414 15.998956-16.001044 15.998956-8.83680266 0-15.998956-7.1642414-15.998956-15.998956 0-8.83680256 7.16215334-16.001044 15.998956-16.001044 8.8368026 0 16.001044 7.16424144 16.001044 16.001044z"
        stroke="#1d1d1b"
      />
      <g
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m18 9 2.2968454 2.2968454 2.7031546 2.7031546-5 5"/>
        <path d="m12 25s0-3.6666667 0-11h10"/>
      </g>
    </g>
  </svg>
);
